var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.isShowText ? 'zy_back' : 'zy_back_ani'],on:{"click":_vm.onBack}},[(_vm.isShowText)?_c('div',{staticClass:"back_text"},[_vm._v(_vm._s(_vm.text))]):_vm._e(),_c('img',{staticClass:"back_icon",attrs:{"src":_vm.icon}})])
}
var staticRenderFns = []

export { render, staticRenderFns }